export const convertYearsToDays = (year: number) => {
  return year * 365;
};
